/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type EventPage_viewer$ref = any;
export type EventPage_QueryVariables = {
    readonly eventId?: string | null;
    readonly trinityPartyId?: string | null;
};
export type EventPage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": EventPage_viewer$ref;
    }) | null;
};
export type EventPage_Query = {
    readonly response: EventPage_QueryResponse;
    readonly variables: EventPage_QueryVariables;
};



/*
query EventPage_Query(
  $eventId: String
  $trinityPartyId: String
) {
  viewer {
    id
    ...EventPage_viewer_A5b7R
  }
}

fragment EventPage_viewer_A5b7R on Viewer {
  id
  ...FeaturedWines_viewer
  event(eventId: $eventId, trinityPartyId: $trinityPartyId) {
    id
    eventId
    eventDate
    createDate
    ceoFirstName
    ceoLastName
    ceoEmail
    ceoFullName
    hostFullName
    hostLastName
    hostFirstName
    hostQuote
    trinityPartyType
    trinityPartyStatus
    hostNonProfitName
    eventAddress {
      city
      state
    }
    closeDate
    donationInfo {
      id
      donationAmount
      donationGoal
      orderDonationAmount
      nonProfit {
        id
        nonProfitName
        nonProfitDescription
      }
      orderCount
    }
    title
    ordersCount
    ceoUser {
      id
      profile {
        image
        id
      }
    }
  }
  user {
    id
    ...AuthDialog_user
    role
    cartV2 {
      id
      cartId
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
      promoCodeSavings
      saleSavings
      canSubscribeForAutoShip
      discountQualifiedCartTotal
      subTotalPriceOfItems
      subTotalPriceOfItemsWithDiscount
      total
      totalSavings
      totalNumberOfItems
      eventId
      eventHostFirstName
      event {
        id
        eventId
        trinityPartyType
      }
      promoCodes {
        id
        code
        promoDescription
        thresholds {
          discountAmount
          discountAmountEach
        }
      }
      wordPressCoupons {
        code
        couponDescription
        storeBalance
        yotpoCouponCode
        id
      }
      wordPressCouponSavings
      entries(first: 1000) {
        edges {
          node {
            id
            sku
            productId
            quantity
            productName
            productURLslug
            productImageUrl
            wineBottleQuantity
            isWinePack
            priceOriginal
            priceSale
            priceDiscount
            discountEligible
            priceDiscountPercent
            hasQualifyingDiscount
          }
        }
      }
    }
  }
}

fragment FeaturedWines_viewer on Viewer {
  id
  productsBulk(first: 6, productIds: ["15b29dc0-27e0-4527-beda-01f1b09babe6", "b502bd0b-73a0-4773-8f34-76941c4bce53", "5fa97b97-9b0c-4c4c-89ba-8458e2b4a856", "21318bf0-779d-40a0-9810-0fd446c344f6", "e05b8a29-5be5-48a3-9034-42e8fc87a096", "91dfc818-b39b-4547-980e-60a8e78ec5e9"]) {
    edges {
      node {
        id
        productId
        name
        price
        priceSale
        inStockOn
        inventoryClass
        inventoryQuantity
        inventorySKU
        reviewAverage
        productURLslug
        optionsId
        options {
          id
          optionId
          optionName
          choiceStyle
          options {
            optionName
          }
        }
        images {
          productCatalog
          id
        }
        content {
          impactSmall
          id
        }
        promoCodeDiscount {
          case4Cause {
            case12PriceUSD
            case6PriceUSD
          }
        }
        ...ProductListItem_product
      }
    }
  }
  user {
    id
    ...ImageGallery_user
    permissions {
      id
      oneCommerce {
        id
        ceo {
          access
        }
      }
    }
    userId
    role
    conciergeUser {
      userId
      id
    }
    cartV2 {
      id
      cartId
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
      promoCodeSavings
      saleSavings
      canSubscribeForAutoShip
      discountQualifiedCartTotal
      subTotalPriceOfItems
      subTotalPriceOfItemsWithDiscount
      total
      totalSavings
      totalNumberOfItems
      eventId
      eventHostFirstName
      event {
        id
        eventId
        trinityPartyType
      }
      promoCodes {
        id
        code
        promoDescription
        thresholds {
          discountAmount
          discountAmountEach
        }
      }
      wordPressCoupons {
        code
        couponDescription
        storeBalance
        yotpoCouponCode
        id
      }
      wordPressCouponSavings
      entries(first: 1000) {
        edges {
          node {
            id
            sku
            productId
            quantity
            productName
            productURLslug
            productImageUrl
            wineBottleQuantity
            isWinePack
            priceOriginal
            priceSale
            priceDiscount
            discountEligible
            priceDiscountPercent
            hasQualifyingDiscount
          }
        }
      }
    }
  }
}

fragment AuthDialog_user on User {
  id
  role
  email
  lastName
  firstName
  hasSSOAccount
  shoppingWithCeoUser {
    userId
    id
  }
  cart {
    id
    eventId
    eventHostFirstName
  }
}

fragment ProductListItem_product on Product {
  id
  isSubscription
  productPermissions {
    oneCommerce {
      preferredCustomer {
        view
        add
      }
      default {
        view
        add
      }
    }
  }
  ranking
  company
  freeUpsGroundShipping
  productId
  name
  category
  price
  priceUSDmin
  priceUSDmax
  year
  priceSale
  reviewAverage
  productURLslug
  parentProduct
  inventoryText
  reviewTotal
  staticUrl
  images {
    productCatalog
    squareFront
    id
  }
  content {
    impactSmall
    summary
    id
  }
  promoCodeDiscount {
    case4Cause {
      case12PriceUSD
      case6PriceUSD
      case6SKU
      case12SKU
      donationEligible
    }
  }
  inventoryClass
  inventorySKU
  inventoryQuantity
}

fragment ImageGallery_user on User {
  ...ProductListItem_user
  role
  conciergeCustomerAccountId
  conciergeUser {
    userId
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
      }
    }
    id
  }
  permissions {
    id
    oneCommerce {
      id
      ceo {
        access
      }
      preferredCustomer {
        access
      }
    }
  }
  cartV2 {
    id
    cartId
    autoShipEnabled
    autoShipIntervalUnit
    autoShipIntervalCount
    promoCodeSavings
    saleSavings
    canSubscribeForAutoShip
    discountQualifiedCartTotal
    subTotalPriceOfItems
    subTotalPriceOfItemsWithDiscount
    total
    totalSavings
    totalNumberOfItems
    eventId
    eventHostFirstName
    event {
      id
      eventId
      trinityPartyType
    }
    promoCodes {
      id
      code
      promoDescription
      thresholds {
        discountAmount
        discountAmountEach
      }
    }
    wordPressCoupons {
      code
      couponDescription
      storeBalance
      yotpoCouponCode
      id
    }
    wordPressCouponSavings
    entries(first: 1000) {
      edges {
        node {
          id
          sku
          productId
          quantity
          productName
          productURLslug
          productImageUrl
          wineBottleQuantity
          isWinePack
          priceOriginal
          priceSale
          priceDiscount
          discountEligible
          priceDiscountPercent
          hasQualifyingDiscount
        }
      }
    }
  }
}

fragment ProductListItem_user on User {
  id
  role
  conciergeCustomerAccountId
  conciergeUser {
    id
    userId
    permissions {
      id
      oneCommerce {
        id
        preferredCustomer {
          access
        }
      }
    }
    subscriptions {
      wineClub {
        enrollmentStatus
        subscriptionStatus
        id
      }
      id
    }
  }
  cartV2 {
    id
    cartId
    discountQualifiedCartTotal
    entries(first: 1000) {
      edges {
        node {
          id
          sku
          productId
          quantity
          productName
          productURLslug
          productImageUrl
          wineBottleQuantity
          isWinePack
          priceOriginal
          priceSale
          priceDiscount
          discountEligible
          priceDiscountPercent
          hasQualifyingDiscount
        }
      }
    }
  }
  subscriptions {
    wineClub {
      enrollmentStatus
      subscriptionStatus
      id
    }
    id
  }
  permissions {
    id
    oneCommerce {
      id
      preferredCustomer {
        access
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "eventId",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "trinityPartyId",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "priceSale",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productURLslug",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "optionName",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "productId",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "view",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "add",
            "args": null,
            "storageKey": null
        } as any)
    ], v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userId",
        "args": null,
        "storageKey": null
    } as any), v8 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "access",
            "args": null,
            "storageKey": null
        } as any)
    ], v9 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "preferredCustomer",
        "storageKey": null,
        "args": null,
        "concreteType": "AccessType",
        "plural": false,
        "selections": (v8 /*: any*/)
    } as any), v10 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "subscriptions",
        "storageKey": null,
        "args": null,
        "concreteType": "Subscriptions",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "wineClub",
                "storageKey": null,
                "args": null,
                "concreteType": "WineClubType",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "enrollmentStatus",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "subscriptionStatus",
                        "args": null,
                        "storageKey": null
                    },
                    (v1 /*: any*/)
                ]
            },
            (v1 /*: any*/)
        ]
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventId",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "eventHostFirstName",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "trinityPartyType",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "EventPage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "EventPage_viewer",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "eventId",
                                    "variableName": "eventId",
                                    "type": null
                                },
                                {
                                    "kind": "Variable",
                                    "name": "trinityPartyId",
                                    "variableName": "trinityPartyId",
                                    "type": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "EventPage_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "productsBulk",
                            "storageKey": "productsBulk(first:6,productIds:[\"15b29dc0-27e0-4527-beda-01f1b09babe6\",\"b502bd0b-73a0-4773-8f34-76941c4bce53\",\"5fa97b97-9b0c-4c4c-89ba-8458e2b4a856\",\"21318bf0-779d-40a0-9810-0fd446c344f6\",\"e05b8a29-5be5-48a3-9034-42e8fc87a096\",\"91dfc818-b39b-4547-980e-60a8e78ec5e9\"])",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 6,
                                    "type": "Int"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "productIds",
                                    "value": [
                                        "15b29dc0-27e0-4527-beda-01f1b09babe6",
                                        "b502bd0b-73a0-4773-8f34-76941c4bce53",
                                        "5fa97b97-9b0c-4c4c-89ba-8458e2b4a856",
                                        "21318bf0-779d-40a0-9810-0fd446c344f6",
                                        "e05b8a29-5be5-48a3-9034-42e8fc87a096",
                                        "91dfc818-b39b-4547-980e-60a8e78ec5e9"
                                    ],
                                    "type": "[String]"
                                }
                            ],
                            "concreteType": "ProductConnection",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ProductEdge",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "content",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Content",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "impactSmall",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "summary",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "name",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "price",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inStockOn",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventoryClass",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventoryQuantity",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventorySKU",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "reviewAverage",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v3 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "optionsId",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "options",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ProductOptions",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "optionId",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v4 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "choiceStyle",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "options",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ProductOptions",
                                                            "plural": true,
                                                            "selections": [
                                                                (v4 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "images",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Images",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "productCatalog",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v1 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "squareFront",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                (v5 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "promoCodeDiscount",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PromoCodeDiscount",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "case4Cause",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Case4Cause",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "case12PriceUSD",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "case6PriceUSD",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "case6SKU",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "case12SKU",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "donationEligible",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "isSubscription",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "productPermissions",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ProductPermissions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "oneCommerce",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "AppProductPermissionsAccess",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "preferredCustomer",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductPermissionsAccess",
                                                                    "plural": false,
                                                                    "selections": (v6 /*: any*/)
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "default",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "ProductPermissionsAccess",
                                                                    "plural": false,
                                                                    "selections": (v6 /*: any*/)
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "ranking",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "company",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "freeUpsGroundShipping",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "category",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "priceUSDmin",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "priceUSDmax",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "year",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "parentProduct",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "inventoryText",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "reviewTotal",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "staticUrl",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                                (v7 /*: any*/),
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "conciergeCustomerAccountId",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "conciergeUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v7 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "permissions",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PermissionsType",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "oneCommerce",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "OneCommerceType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        (v9 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v10 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cartV2",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CartV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "subTotalPriceOfItems",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v1 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "discountQualifiedCartTotal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "entries",
                                            "storageKey": "entries(first:1000)",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 1000,
                                                    "type": "Int"
                                                }
                                            ],
                                            "concreteType": "CartEntryV3Connection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "CartEntryV3Edge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CartEntryV3",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "wineBottleQuantity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v1 /*: any*/),
                                                                (v5 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "quantity",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "productName",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v3 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "productImageUrl",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "sku",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "isWinePack",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceOriginal",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v2 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceDiscount",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "discountEligible",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "priceDiscountPercent",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "hasQualifyingDiscount",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "autoShipEnabled",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "autoShipIntervalUnit",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "autoShipIntervalCount",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "promoCodeSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "saleSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canSubscribeForAutoShip",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "cartId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "subTotalPriceOfItemsWithDiscount",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "total",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalSavings",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalNumberOfItems",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v11 /*: any*/),
                                        (v12 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "event",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Event",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                (v11 /*: any*/),
                                                (v13 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "promoCodes",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PromoCode",
                                            "plural": true,
                                            "selections": [
                                                (v1 /*: any*/),
                                                (v14 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "promoDescription",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "thresholds",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PromoCodeThresholds",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "discountAmount",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "discountAmountEach",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "wordPressCoupons",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "WordPressCoupon",
                                            "plural": true,
                                            "selections": [
                                                (v14 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "couponDescription",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "storeBalance",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "yotpoCouponCode",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v1 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "wordPressCouponSavings",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                (v10 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "permissions",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PermissionsType",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oneCommerce",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OneCommerceType",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                (v9 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "ceo",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AccessType",
                                                    "plural": false,
                                                    "selections": (v8 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "role",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "email",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "lastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "firstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hasSSOAccount",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shoppingWithCeoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v1 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "cart",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Cart",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v11 /*: any*/),
                                        (v12 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "event",
                            "storageKey": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "eventId",
                                    "variableName": "eventId",
                                    "type": "String"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "trinityPartyId",
                                    "variableName": "trinityPartyId",
                                    "type": "String"
                                }
                            ],
                            "concreteType": "Event",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hostFirstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v1 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "eventDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "createDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "ceoFirstName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "ceoLastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "ceoEmail",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "ceoFullName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hostFullName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hostLastName",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v11 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hostQuote",
                                    "args": null,
                                    "storageKey": null
                                },
                                (v13 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "trinityPartyStatus",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "hostNonProfitName",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "eventAddress",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "OrderAddress",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "city",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "state",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "closeDate",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "donationInfo",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "DonationInfo",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "donationAmount",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "donationGoal",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "orderDonationAmount",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "nonProfit",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "NonProfit",
                                            "plural": false,
                                            "selections": [
                                                (v1 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "nonProfitName",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "nonProfitDescription",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "orderCount",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "title",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "ordersCount",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "ceoUser",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "profile",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "Profile",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "image",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v1 /*: any*/)
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "EventPage_Query",
            "id": null,
            "text": "query EventPage_Query(\n  $eventId: String\n  $trinityPartyId: String\n) {\n  viewer {\n    id\n    ...EventPage_viewer_A5b7R\n  }\n}\n\nfragment EventPage_viewer_A5b7R on Viewer {\n  id\n  ...FeaturedWines_viewer\n  event(eventId: $eventId, trinityPartyId: $trinityPartyId) {\n    id\n    eventId\n    eventDate\n    createDate\n    ceoFirstName\n    ceoLastName\n    ceoEmail\n    ceoFullName\n    hostFullName\n    hostLastName\n    hostFirstName\n    hostQuote\n    trinityPartyType\n    trinityPartyStatus\n    hostNonProfitName\n    eventAddress {\n      city\n      state\n    }\n    closeDate\n    donationInfo {\n      id\n      donationAmount\n      donationGoal\n      orderDonationAmount\n      nonProfit {\n        id\n        nonProfitName\n        nonProfitDescription\n      }\n      orderCount\n    }\n    title\n    ordersCount\n    ceoUser {\n      id\n      profile {\n        image\n        id\n      }\n    }\n  }\n  user {\n    id\n    ...AuthDialog_user\n    role\n    cartV2 {\n      id\n      cartId\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n      promoCodeSavings\n      saleSavings\n      canSubscribeForAutoShip\n      discountQualifiedCartTotal\n      subTotalPriceOfItems\n      subTotalPriceOfItemsWithDiscount\n      total\n      totalSavings\n      totalNumberOfItems\n      eventId\n      eventHostFirstName\n      event {\n        id\n        eventId\n        trinityPartyType\n      }\n      promoCodes {\n        id\n        code\n        promoDescription\n        thresholds {\n          discountAmount\n          discountAmountEach\n        }\n      }\n      wordPressCoupons {\n        code\n        couponDescription\n        storeBalance\n        yotpoCouponCode\n        id\n      }\n      wordPressCouponSavings\n      entries(first: 1000) {\n        edges {\n          node {\n            id\n            sku\n            productId\n            quantity\n            productName\n            productURLslug\n            productImageUrl\n            wineBottleQuantity\n            isWinePack\n            priceOriginal\n            priceSale\n            priceDiscount\n            discountEligible\n            priceDiscountPercent\n            hasQualifyingDiscount\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment FeaturedWines_viewer on Viewer {\n  id\n  productsBulk(first: 6, productIds: [\"15b29dc0-27e0-4527-beda-01f1b09babe6\", \"b502bd0b-73a0-4773-8f34-76941c4bce53\", \"5fa97b97-9b0c-4c4c-89ba-8458e2b4a856\", \"21318bf0-779d-40a0-9810-0fd446c344f6\", \"e05b8a29-5be5-48a3-9034-42e8fc87a096\", \"91dfc818-b39b-4547-980e-60a8e78ec5e9\"]) {\n    edges {\n      node {\n        id\n        productId\n        name\n        price\n        priceSale\n        inStockOn\n        inventoryClass\n        inventoryQuantity\n        inventorySKU\n        reviewAverage\n        productURLslug\n        optionsId\n        options {\n          id\n          optionId\n          optionName\n          choiceStyle\n          options {\n            optionName\n          }\n        }\n        images {\n          productCatalog\n          id\n        }\n        content {\n          impactSmall\n          id\n        }\n        promoCodeDiscount {\n          case4Cause {\n            case12PriceUSD\n            case6PriceUSD\n          }\n        }\n        ...ProductListItem_product\n      }\n    }\n  }\n  user {\n    id\n    ...ImageGallery_user\n    permissions {\n      id\n      oneCommerce {\n        id\n        ceo {\n          access\n        }\n      }\n    }\n    userId\n    role\n    conciergeUser {\n      userId\n      id\n    }\n    cartV2 {\n      id\n      cartId\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n      promoCodeSavings\n      saleSavings\n      canSubscribeForAutoShip\n      discountQualifiedCartTotal\n      subTotalPriceOfItems\n      subTotalPriceOfItemsWithDiscount\n      total\n      totalSavings\n      totalNumberOfItems\n      eventId\n      eventHostFirstName\n      event {\n        id\n        eventId\n        trinityPartyType\n      }\n      promoCodes {\n        id\n        code\n        promoDescription\n        thresholds {\n          discountAmount\n          discountAmountEach\n        }\n      }\n      wordPressCoupons {\n        code\n        couponDescription\n        storeBalance\n        yotpoCouponCode\n        id\n      }\n      wordPressCouponSavings\n      entries(first: 1000) {\n        edges {\n          node {\n            id\n            sku\n            productId\n            quantity\n            productName\n            productURLslug\n            productImageUrl\n            wineBottleQuantity\n            isWinePack\n            priceOriginal\n            priceSale\n            priceDiscount\n            discountEligible\n            priceDiscountPercent\n            hasQualifyingDiscount\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AuthDialog_user on User {\n  id\n  role\n  email\n  lastName\n  firstName\n  hasSSOAccount\n  shoppingWithCeoUser {\n    userId\n    id\n  }\n  cart {\n    id\n    eventId\n    eventHostFirstName\n  }\n}\n\nfragment ProductListItem_product on Product {\n  id\n  isSubscription\n  productPermissions {\n    oneCommerce {\n      preferredCustomer {\n        view\n        add\n      }\n      default {\n        view\n        add\n      }\n    }\n  }\n  ranking\n  company\n  freeUpsGroundShipping\n  productId\n  name\n  category\n  price\n  priceUSDmin\n  priceUSDmax\n  year\n  priceSale\n  reviewAverage\n  productURLslug\n  parentProduct\n  inventoryText\n  reviewTotal\n  staticUrl\n  images {\n    productCatalog\n    squareFront\n    id\n  }\n  content {\n    impactSmall\n    summary\n    id\n  }\n  promoCodeDiscount {\n    case4Cause {\n      case12PriceUSD\n      case6PriceUSD\n      case6SKU\n      case12SKU\n      donationEligible\n    }\n  }\n  inventoryClass\n  inventorySKU\n  inventoryQuantity\n}\n\nfragment ImageGallery_user on User {\n  ...ProductListItem_user\n  role\n  conciergeCustomerAccountId\n  conciergeUser {\n    userId\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    id\n  }\n  permissions {\n    id\n    oneCommerce {\n      id\n      ceo {\n        access\n      }\n      preferredCustomer {\n        access\n      }\n    }\n  }\n  cartV2 {\n    id\n    cartId\n    autoShipEnabled\n    autoShipIntervalUnit\n    autoShipIntervalCount\n    promoCodeSavings\n    saleSavings\n    canSubscribeForAutoShip\n    discountQualifiedCartTotal\n    subTotalPriceOfItems\n    subTotalPriceOfItemsWithDiscount\n    total\n    totalSavings\n    totalNumberOfItems\n    eventId\n    eventHostFirstName\n    event {\n      id\n      eventId\n      trinityPartyType\n    }\n    promoCodes {\n      id\n      code\n      promoDescription\n      thresholds {\n        discountAmount\n        discountAmountEach\n      }\n    }\n    wordPressCoupons {\n      code\n      couponDescription\n      storeBalance\n      yotpoCouponCode\n      id\n    }\n    wordPressCouponSavings\n    entries(first: 1000) {\n      edges {\n        node {\n          id\n          sku\n          productId\n          quantity\n          productName\n          productURLslug\n          productImageUrl\n          wineBottleQuantity\n          isWinePack\n          priceOriginal\n          priceSale\n          priceDiscount\n          discountEligible\n          priceDiscountPercent\n          hasQualifyingDiscount\n        }\n      }\n    }\n  }\n}\n\nfragment ProductListItem_user on User {\n  id\n  role\n  conciergeCustomerAccountId\n  conciergeUser {\n    id\n    userId\n    permissions {\n      id\n      oneCommerce {\n        id\n        preferredCustomer {\n          access\n        }\n      }\n    }\n    subscriptions {\n      wineClub {\n        enrollmentStatus\n        subscriptionStatus\n        id\n      }\n      id\n    }\n  }\n  cartV2 {\n    id\n    cartId\n    discountQualifiedCartTotal\n    entries(first: 1000) {\n      edges {\n        node {\n          id\n          sku\n          productId\n          quantity\n          productName\n          productURLslug\n          productImageUrl\n          wineBottleQuantity\n          isWinePack\n          priceOriginal\n          priceSale\n          priceDiscount\n          discountEligible\n          priceDiscountPercent\n          hasQualifyingDiscount\n        }\n      }\n    }\n  }\n  subscriptions {\n    wineClub {\n      enrollmentStatus\n      subscriptionStatus\n      id\n    }\n    id\n  }\n  permissions {\n    id\n    oneCommerce {\n      id\n      preferredCustomer {\n        access\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'b9f7310877b7d587597c12cdec6e3c2c';
export default node;
